import { useQuery } from 'react-query';

import { api } from '../../../../static/api';
import { QueryAliases } from '../../../../types/QueryAliases';
import useAxiosInstance from '../../../axios/useAxiosInstance';
import { ApiTeamRef, hasTeamRef, toTeamMessage } from './transformTeamMessage';

interface ApiSentMessage {
  createdAt: string;
  game: number;
  id: number;
  message: string;
  receiver: ApiTeamRef | string | undefined;
  sender: string;
  wasRead: boolean;
}

interface useGameSentMessagesProps {
  gameId: string;
}

const useGameSentMessages = ({ gameId }: useGameSentMessagesProps) => {
  const axiosInstance = useAxiosInstance();

  const { data, isLoading, isError } = useQuery(
    [QueryAliases.GAME_SENT_MESSAGES(gameId)],
    () => axiosInstance.get(api.endpoints.GAME_SENT_MESSAGES({ gameId })),
    { refetchOnMount: true },
  );

  const apiMessages: ApiSentMessage[] | undefined = data?.data;

  const iMessages = !!apiMessages
    ? apiMessages
        .filter(apiMessage => hasTeamRef(apiMessage.receiver))
        .map(apiMessage => toTeamMessage(apiMessage, apiMessage.receiver as ApiTeamRef, false))
    : undefined;

  return { messages: iMessages, isLoading, isError };
};

export default useGameSentMessages;
